module.exports = __webpack_public_path__ + "img/r-123.83aaec3d.jpg";